import { render, staticRenderFns } from "./d-discover-feed-entries.vue?vue&type=template&id=1b4032e6&scoped=true&"
import script from "./d-discover-feed-entries.vue?vue&type=script&lang=js&"
export * from "./d-discover-feed-entries.vue?vue&type=script&lang=js&"
import style0 from "./d-discover-feed-entries.vue?vue&type=style&index=0&id=1b4032e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4032e6",
  null
  
)

export default component.exports